import React from 'react'

export default function Imprint() {
    return (
        <div className="imprint">
            <h1>Imprint</h1>
            <ul>
                <li>
                    <strong>Christian Gregor</strong>
                </li>
                <li>
                    <strong>VAT ID: DE249761723</strong>
                </li>
                <li>
                    Richardplatz 21
                </li>
                <li>
                    12055 Berlin
                </li>
                <li>
                    Germany
                </li>
                <li>
                    <a href="mailto:grgr@3motic.com">
                        grgr@3motic.com
                    </a>
                </li>
            </ul>

            <div className='collaborate'>
                <h2>Collaboration</h2>
                <p>
                    I am a freelance software developer since 2006.
                    I am always interested in new projects.
                    My tech stack is:
                </p>
                <ul>
                    <li>Linux (Ubuntu/ Debian)</li>
                    <li>(n)vim</li>
                    <li>Ruby on Rails (fullstack)</li>
                    <li>React</li>
                    <li>React Three Fiber / Three.js</li>
                    <li>Blender, Phython</li>
                </ul>    
                <p>
                    Contact me at <a href="mailto:grgr@3motic.com">grgr@3motic.com</a>
                </p>
            </div>
        </div>
    )
}

